import React from 'react';

import '@rmwc/tabs/styles';

import ContactsOffices from './ContactsOffices';

const CompanyContactsDetailed = () => (
  <div id="offices" className="contact-detailed">
    <div className="container">
      <ContactsOffices />
    </div>
  </div>
);

export default CompanyContactsDetailed;
